export function useHeader() {
    const defaultsStore = useDefaultsStore();
    const windowScroll = useWindowScroll();
    const isScrollingUp = ref(false);
    
    const hideOffset = computed(() => defaultsStore.headerHeight + defaultsStore.bannerHeight);

    const isSticky = computed(() => windowScroll.y.value > defaultsStore.bannerHeight);

    const isHidden = computed(() => {
        if (windowScroll.y.value > hideOffset.value) return !isScrollingUp.value;
        return false;
    });

    watch(windowScroll.y, () => { isScrollingUp.value = windowScroll.directions.top });

    return {
        hideOffset,
        isSticky,
        isHidden,
    };
}